import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class QuantityLessThanZeroError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.common.validation.items.quantity.quantity-less-than-zero');
    }
}
